import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-boxes',
  templateUrl: './contact-boxes.component.html',
  styleUrls: ['./contact-boxes.component.scss']
})
export class ContactBoxesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
